import React, {useState, useRef} from 'react';
import styles from './SocialMediaIconModal.module.scss';
import {useSelector} from 'react-redux';
import {styled} from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import {useTranslation} from 'react-i18next';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import {selectMediakitUser} from './../../features/stores/mediakitUser.slice';
import InputTextField from './../InputTextField';
import {ExploreModalData, socialMediaLinks} from '../../constants/socialMedia';
import {extendUrl} from '../../Helper/generalHelper';

interface IProps{
    handleClose: () => void;
    orderNumber: number;
    handleChosePlatform: Function;
};

const ButtonCustom = styled(Button)({
    background: '#7066FF',
    color: '#fff',
    padding: '16px 24px',
    borderRadius: '40px',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    textTransform: 'capitalize',
  });

const SocialMediaIconModal = ({handleClose, orderNumber, handleChosePlatform}: IProps) => {
  const {t} = useTranslation();
  const [currentView, setCurrentView] = useState('CHOOSE-LINK');
  const mediakitUser = useSelector(selectMediakitUser);
  const socialSectionData = mediakitUser.mediakitSection.find(
    (section: any) => section.type === 'social',
    );
  const [addObj, setAddObj] = useState<any>({});
  const node = useRef(null);
  const handleBackwardClick = () => {
    if (currentView == 'ADD-LINK') {
        setCurrentViewHandle('CHOOSE-LINK');  
    }
  };
  const determineIcon = () => {
    return socialMediaLinks.find((e: any) => e.key === addObj?.platform)?.defaultIconTransparent;
  };

  const handleChangeUrl = (url: any) => {
    setAddObj({...addObj, url: url});
  };

  const setCurrentViewHandle = (value: string, item?: any) => {
    if (value == 'ADD-LINK') {
        const obj = {
            id: Date.now(), // id generated via UTC date (unique), so that we can later delete this item (this id is not sent do backend)
            url: '',
            orderNumber: orderNumber || 0,
            mediakitSectionId: socialSectionData?.id,
            platform: item.key,
            isVisible: true,
        };
        setAddObj(obj);  
    }
    setCurrentView(value);
  };

  const handleAddLink = () => {
     handleChosePlatform({...addObj, url: extendUrl({type: addObj?.platform, url: addObj?.url})}, true);
     handleClose();
  };

  const getContentBody = () => {
    switch (currentView) {
        case 'CHOOSE-LINK': 
            return <>
            <div className={styles.head_container} style={{justifyContent: 'center'}}>
                <div className={styles.head_left}>
                    <div className={styles.text_center}>{t('icons')}</div>
                    <div className={styles.quick_link}>{t('quick_link_to_your_social_media_accounts')}</div>
                </div>
            </div>
            <div className={styles.box_body}>
                {ExploreModalData?.map((item: any, index: number) => (
                    <div className={styles.card_item_box} key={`${item.key}-${index}`}>
                        <div className={styles.card_item_box_left}>
                            <div className={styles.icon_container}><img src={item.defaultIcon} /></div>
                            <div className={styles.card_item_box_middle}>
                                <div className={styles.name}>{item.name}</div>
                            </div>
                        </div>
                        <div className={styles.card_item_box_right} onClick={() => setCurrentViewHandle('ADD-LINK', item)}>
                          <AddCircleIcon htmlColor="black" />
                        </div>
                    </div>
                ))}    
            </div>
            </>; 
        case 'ADD-LINK': 
            const linkType = socialMediaLinks.find((e: any) => e.key === addObj.platform)?.name;
            return <>
            <div>
                <div className={styles.text_center}>{linkType}</div>
            </div>
            <div className={`${styles.box_body} ${styles.box_add_single} ${styles.link}`}>
                <InputTextField
                  placeholder={linkType}
                  value={addObj.url}
                  customstyle={{height: '56px', padding: '0px'}}
                  onChange={(e: any) => handleChangeUrl(e.target.value)}
                  icon={determineIcon()!} />
            </div>
            <div className={styles.add_footer}>
                 <ButtonCustom disabled={!!!addObj?.url?.length} onClick={handleAddLink} variant="contained" size="large">{t('add')}</ButtonCustom>
            </div>
            </>;             
        default:
            break;       
   } 
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.modal}>
          <div className={`${styles.modal_content} ${currentView == 'ADD-LINK' ? styles.add_link : ''}`}>
              <div className={styles.cross} onClick={handleClose}><CloseIcon /></div>
              <div className={styles.content_body}>
                {getContentBody()}
              </div>
              
          </div>
        </div>
      </div>
    </>
  );
};

export default SocialMediaIconModal;
